import { isRunTime } from "./isRunTime";
import { scrollTo } from "./scroll";

const updateViewportHeight = () => {
  if (!isRunTime()) return null;
  let vh = window.innerHeight * 0.01;
  let vwh =
    window && window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  document.documentElement.style.setProperty("--vwh", `${vwh}px`);
};

const addViewportHeightResizeEventListener = () => {
  if (isRunTime()) {
    updateViewportHeight();
    window.addEventListener("resize", updateViewportHeight);
  }
};
const removeViewportHeightResizeEventListener = () => {
  if (isRunTime()) window.removeEventListener("resize", updateViewportHeight);
};


function scrollToAnchor(options = {}) {
  if (!isRunTime()) return false;
  if (options?.anchor && options?.anchor !== '') {
    window.location.hash = 'payment-details';
  }
  if (window.location.hash) {
    setTimeout(() => {
      let yOffset = 0;
      if (document.getElementById('topbar')) {
        const rect = document.getElementById('topbar').getBoundingClientRect();
        yOffset += rect.top + rect.height;
      }
      const elementId = window.location.hash.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY - yOffset;
        scrollTo({ top: y, behavior: options?.behavior || 'auto' });
      }
    }, 100);
    return true;
  }
  return false;
}

/*
  options:
  - anchor: the anchor identifier
  - behavior: auto, instant, smooth
*/
function goToAnchor(options = {}) {
  scrollToAnchor(options);
}

/**
 * Calculates the sticky offset needed to position elements below toolbar/topbar
 * @param {number} margin - Additional margin to add to the offset
 * @param {Object} context - ApplicationContext to get heights from
 * @returns {number} The total offset in pixels
 */
function getStickyOffset(margin = 0, context = null) {
  if (!context?.headerHeights) {
    return margin;
  }
  
  const { toolbar = 0, toolbarMobile = 0, topbar = 0, toastbar = 0 } = context.headerHeights;
  return toolbar + toolbarMobile + topbar + toastbar + margin;
}

export {
  updateViewportHeight,
  addViewportHeightResizeEventListener,
  removeViewportHeightResizeEventListener,
  goToAnchor,
  getStickyOffset,
};
